export const blue = "#1C86C2";
export const orange = "#FA6900";
